<div #map class="mapContainer">
  <div class="map">
    <img  *ngIf="view === 'TowerView' || view === 'Los'" class="img-fluid" #circle [src]="'assets/images/map/'+view+'.png'" />
   <h5 *ngIf="view == 'TopDown'" class="height" #altitude>Altitude from Ground : {{ height }} m</h5>
  </div>
  <i *ngIf="view == 'TowerView' || view === 'Los'" class="angle">Angle from N : {{ angle }} ° </i>
</div>
